import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, InputBase, Paper, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import loaderGif from "../../Assests/loader.gif";
import Table from '../../Components/Table';
import { SCACTypeColumns } from '../../ColumnsConfig/SCACTypeColumns';
import SCACTypeFormDialog from '../../Modals/SCACTypeFormDialog';
import ConfirmationModal from '../../Common/ConfirmationModal';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ScacTypeService from '../../Services/ScacType';
const SCACType = () => {
  const [rows, setRows] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [chipValue, setChipValue] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortColumn] = useState(''); 
  const [order, setSortOrder] = useState("asc"); 
  const [filteredRows, setFilteredRows] = useState([]);
  const [recordDeleted, setRecordDeleted] = useState(false); 
  const [deleteError, setDeleteError] = useState(false);
  const [createRecord, setCreateRecord] = useState(false); 
  const [createRecordError, setCreateRecordError] = useState(false); 
  const [updateRecord, setUpdateRecord] = useState(false); 
  const [updateRecordError, setUpdateRecordError] = useState(false);
  const [scacType, setScacType] = useState('');
  const validSortFields = ['scac_type', 'description'];

const fetchScacType = async (
  page = currentPage,
  size = pageSize,
  sortByField = sortBy,
  sortOrder = order,
  searchTerm = scacType
) => {
  setIsLoading(true);
  try {
    const sanitizedOrder = sortOrder === 'asc' || sortOrder === 'desc' ? sortOrder : 'asc'; // Default to 'asc' if invalid
    const queryObj = {
      page,
      pageSize: size,
      sortBy: validSortFields.includes(sortByField) ? sortByField : 'scac_type',
      order: sanitizedOrder,
      searchTerm: searchTerm.trim() || "",
    };

    const response = await ScacTypeService.fetchScacType(
      queryObj.page,
      queryObj.pageSize,
      queryObj.sortBy,
      queryObj.order,
      queryObj.searchTerm,
    );

    const { data, totalRecords, totalPages } = response;

    if (Array.isArray(data)) {
      setRows(data.map(row => ({ ...row, id: row.scac_type_id })));
      setTotalRecords(totalRecords);
      setTotalPages(totalPages);
    } else {
      throw new Error('Unexpected API response format.');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.ErrorMessage || "Failed to fetch ScacType data.";
    console.error('Failed to fetch ScacType data:', errorMessage);
    NotificationManager.error(errorMessage, "Error", 5000);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchScacType();
}, [currentPage, pageSize]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };
  useEffect(() => {
    fetchScacType(currentPage, pageSize,sortBy, order,scacType);
  }, [currentPage, pageSize,sortBy, order]);

  useEffect(() => {
    if (recordDeleted || deleteError || createRecord || createRecordError || updateRecord ||updateRecordError ) {
      const timer = setTimeout(() => {
        setRecordDeleted(false);
        setDeleteError(false);
        setCreateRecord(false);
        setCreateRecordError(false);
        setUpdateRecord(false);
        setUpdateRecordError(false)
    
      }, 5000); // Hide alert after 5 seconds
      return () => clearTimeout(timer); // Cleanup timer if component unmounts
    }
  }, [recordDeleted, deleteError,createRecord,createRecordError,updateRecord]);
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };
   // Apply sorting to the entire data set, then paginate
   const filterRows = (value) => {
    let filteredData = rows.slice(); // Create a copy of the rows

    // Filter the sorted data based on the search value
    const searchFilteredData = filteredData.filter(row =>
      row.name && row.name.toLowerCase().includes(value.toLowerCase())
    );

    // Paginate the filtered data
    setFilteredRows(searchFilteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize));
    setTotalRecords(searchFilteredData.length);
    setTotalPages(Math.ceil(searchFilteredData.length / pageSize));
  };
  // // Handle sorting: Change sort field and order
  const handleSort = (field) => {
  const newSortOrder = sortBy === field && order === 'asc' ? 'desc' : 'asc';
  setSortColumn(field); // Update the sorted column
  setSortOrder(newSortOrder); // Toggle the sort order
  fetchScacType(currentPage, pageSize, searchValue, field, newSortOrder); // Fetch sorted data
};
const handleSearch = () => {
  const trimmedSearchTerm = scacType.trim(); 
  setChipValue(trimmedSearchTerm);
  fetchScacType(1, pageSize, sortBy, order, trimmedSearchTerm); 
};

const handleChipDelete = async() => {
  setChipValue('');
  try{
    await fetchScacType(1, pageSize, sortBy, order, '');

  }catch(error){
    console.error('Error fetching SCAC data:', error);
    //NotificationManager.error("Failed to fetch SCAC data.", "Error", 5000);
  }finally{
    setScacType('');
  }
};
  const handleDialogOpen = () => {
    setInitialData(null);
    setIsDialogOpen(true);
  };
  const handleDialogClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setIsDialogOpen(false);
    }
  };
  const handleSave = async (formData) => {
    try {
      const { scac_type_id, scac_type, description } = formData;
  
      if (scac_type_id) {
        // Update SCAC Type
        const updateData = { description };
        await ScacTypeService.updateSCACType(formData.scac_type_id, updateData);
        NotificationManager.success("SCACTYPE Updated successfully.", "Success", 3000);
      } else {
        // Create new SCAC Type
        const newSCACType = { scac_type, description };
        await ScacTypeService.createSCACType(newSCACType);
        NotificationManager.success("SCACTYPE saved successfully.", "Success", 3000);
      }
  
      fetchScacType(); // Refresh the table data
      setIsDialogOpen(false);
      setCreateRecord(true);    
    } catch (error) {
      console.error('Error saving SCAC TYPE:', error);
      const errorMessage = error.response?.data?.ErrorMessage || "Failed to save SCAC TYPE.";
      NotificationManager.error(errorMessage, "Error", 5000);
    }
  };
  
  
  const handleEdit = (rowData) => {
    setInitialData(rowData);
    setIsDialogOpen(true);
  };
  const handleDelete = (rowData) => {
    setRowToDelete(rowData);
    setIsDeleteModalOpen(true);
  };
  const handleConfirmDelete = async () => {
    if (!rowToDelete) return;
    try {
      const scac_type_id = rowToDelete.scac_type_id;
      await ScacTypeService.deleteSCACType(scac_type_id);
      setRows(rows.filter(row => row.scac_type_id !== rowToDelete.scac_type_id));
      setIsDeleteModalOpen(false);
      setRecordDeleted(true)
      NotificationManager.success("SCAC Type deleted successfully.", "Success", 3000);

    } catch (error) {
      if (error.message.includes("400")) {
        NotificationManager.warning("Please check your inputs.", "Bad Request", 5000);
      } else if (error.message.includes("404")) {
        NotificationManager.info("Resource not found.", "Not Found", 5000);
      } else if (error.message.includes("500")) {
        NotificationManager.error("Server error. Please try again.", "Internal Server Error", 5000);
      } else {
        NotificationManager.error(`Error: ${error.message}`, "Save Failed", 5000);
      }
      console.error('Error deleting SCAC Type:', error);
      setDeleteError(true);

    }
  };
  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };
  return (
    <div className="px-5 my-1" style={{ position: 'relative' }}>
      <NotificationContainer />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center">
          <Paper component="form" className="search-container" onSubmit={(e) => e.preventDefault()}>
            <InputBase
              className="search-input"
              placeholder="Search SCAC Types"
              inputProps={{ 'aria-label': 'search SCAC types' }}
              value={scacType}
              onChange={(e) => setScacType(e.target.value)}
            />
            <IconButton type="button" aria-label="search" onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Paper>
          {chipValue && (
            <Chip
              label={chipValue}
              onDelete={handleChipDelete}
              deleteIcon={<CloseIcon />}
              className="chip-style"
            />
          )}
        </Box>
        <Button variant="contained" onClick={handleDialogOpen} className="add-new-btn">
          Add New SCAC Type
        </Button>
      </Box>
    
      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.8)"
          zIndex={1}
        >
          <img src={loaderGif} alt="Loading..." width={50} height={50} />
        </Box>
      )}
      
      <Table
       rows={rows}
       columns={SCACTypeColumns(handleEdit, handleDelete)}
        className="table-header"
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecords={totalRecords}
        onPageChange={handlePageChange}
        totalPages={totalPages}
        getRowId={(row) => row.scac_type_id}
        onSort={handleSort}
        
      />
      <SCACTypeFormDialog
        open={isDialogOpen}
        handleClose={handleDialogClose}
        handleSave={handleSave}
        initialData={initialData}
      />
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message="Are you sure you want to delete this SCAC Type?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};
export default SCACType;